import React, { Component } from 'react';
import './index.less';
import Banner from '../../components/Banner/h5';
//import CardContent from '../../components/CardContent';
import JumpPc from '../../components/JumpPc/h5';
import H5Card from '../../components/H5Card/h5';
import { inject, observer } from 'mobx-react';
@inject('dashboardStore')
@observer
class Computer extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  async componentDidMount() {
    const Content = await window.$ACE.get('Content');
    const goods = await Content.fetchGoods(window.tms.moduleinfo.id);
    this.setState({
      data: goods
    });
    await this.props.dashboardStore.init();
    if(this.props.dashboardStore.isLogin){
      $.ajax({
        url:'//page.aliyun.com/form/open/set_manjian/submit',
        type: 'post',
        data: {
          'zhanghao': '12'
        },
        xhrFields: {
          withCredentials: true
        },
        success: (res) => {
          const code = res.code;
          if (code == 200 || code == '200') {
            console.log('successs');
          } else {
            console.warn(res);
          }
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          console.log(XMLHttpRequest, textStatus, errorThrown);
        }
      });
    }
  }
  render() {
    //本次只上一版，所以把锚点和其他的模块先注释掉
    if (this.state.data) {
      return (
        <div>
          <Banner/>
          <JumpPc/>
          <H5Card {...this.state.data}/>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Computer;


// WEBPACK FOOTER //
// ./src/scripts/containers/H5/index.js